//
// Generated class AccountingJournalTemplate
//

/// <reference path="AccountingJournalTemplate_ManagedObject.ts" />

class AccountingJournalTemplate extends AccountingJournalTemplate_ManagedObject
{

}
